// extracted by mini-css-extract-plugin
export default {"header":"style_header__C5mBN","subheader":"style_subheader__9NXi0"};